/**
 * Per-tool catalog groups for the agent tools UI.
 * Mirrors integrations-service AgentToolCategoryOverrides so grouping stays
 * correct even before the catalog API is redeployed.
 */
export const TOOL_CATEGORY_OVERRIDES = {
  web_search: "Web",
  http_request: "Web",
  extract_webpage: "Web",
  send_email: "Email",
  send_slack_component: "Messaging",
  run_code: "Code",
  generate_document: "Files",
  schedule_message: "Scheduling",
  compact_context: "Context",
  edit_scheduled_message: "Scheduling",
  recurring_schedule: "Scheduling",
  edit_recurring_schedule: "Scheduling",
  list_agents: "Agents",
  list_agent_sessions: "Agents",
  send_message: "Agents",
  get_self_config: "Agents",
  update_self_config: "Agents",
  create_agent: "Agents",
  list_workflows: "Workflows",
  run_workflow: "Workflows",
  read_workflow: "Workflows",
  read_component: "Workflows",
  publish_workflow: "Workflows",
  unpublish_workflow: "Workflows",
  update_workflow_details: "Workflows",
  get_workflow_history: "Workflows",
  list_versions: "Workflows",
  get_version: "Workflows",
  trigger_workflow: "Workflows",
  list_sessions: "Sessions",
  get_session: "Sessions",
  terminate_session: "Sessions",
  retry_session_component: "Sessions",
  get_error_handling: "Sessions",
  update_error_handling: "Sessions",
  prepare_rerun_inputs: "Sessions",
  rerun_session: "Sessions",
  list_tables: "Tables",
  get_table: "Tables",
  create_table: "Tables",
  add_column: "Tables",
  rename_column: "Tables",
  delete_column: "Tables",
  create_row: "Tables",
  update_row: "Tables",
  query_table: "Tables",
  delete_row: "Tables",
  list_views: "Tables",
  create_view: "Tables",
  update_view: "Tables",
  list_agent_tasks: "Tasks & Forms",
  list_agent_forms: "Tasks & Forms",
  form_fields: "Tasks & Forms",
  get_form: "Tasks & Forms",
  fill_form: "Tasks & Forms",
  review_task: "Tasks & Forms",
  plan_tasks: "Tasks & Forms",
  update_task_queue: "Tasks & Forms",
  search_agent_files: "Files",
  upload_agent_file_from_text: "Files",
  upload_agent_file_from_url: "Files",
  delete_agent_file: "Files",
  get_agent_file_download_url: "Files",
  read_file: "Files",
  edit_agent_file: "Files",
  create_markdown_file: "Files",
  create_text_file: "Files",
  create_json_file: "Files",
  create_csv_file: "Files",
  create_calendar_event: "Calendar",
  read_calendar_event: "Calendar",
  edit_calendar_event: "Calendar",
};

/** Legacy catalog category labels that should never appear as UI groups. */
const LEGACY_CATALOG_CATEGORIES = new Set(["Actions", "Code & Documents"]);

/**
 * @param {string} toolName
 * @param {string} apiCategory
 * @returns {string}
 */
export function resolveToolCategoryTitle(toolName, apiCategory) {
  if (toolName && TOOL_CATEGORY_OVERRIDES[toolName]) {
    return TOOL_CATEGORY_OVERRIDES[toolName];
  }
  const normalized = String(apiCategory || "").trim();
  if (!normalized || LEGACY_CATALOG_CATEGORIES.has(normalized)) {
    return "General";
  }
  return normalized;
}
